import { Delete } from "@mui/icons-material";
import { Box, Checkbox, Container, Icon, IconButton, Table, TableBody, TableCell, TableRow, TextField, Tooltip, Typography } from '@mui/material';
import Grid2 from '@mui/material/Unstable_Grid2';
import { AxiosResponse } from "axios";
import CardTotalizador, { CardTotalizadorLabel, CardTotalizadorValue } from "components/cards/CardTotalizador";
import FixarDescontoDialog from "components/fixardesconto/FixarDescontoDialog";
import FloatingActions, { FloatingActionsProps } from 'components/floatingactions/FloatingActions';
import InfiniteScrollVirtuoso, { HeaderInfiniteScrollVirtuoso, InfiniteScrollTableProps, RowInfiniteScrollVirtuosoProps } from 'components/infinitescrollvirtuoso/InfiniteScrollVirtuoso';
import ConsumidorInput, { ConsumidorInputComponent } from 'components/inputs/consumidorinput/ConsumidorInput';
import SkuInput, { SkuInputComponent } from 'components/inputs/skuinput/SkuInput';
import VendedorInput, { VendedorInputComponent } from 'components/inputs/vendedorinput/VendedorInput';
import CustomProdutoImagensDialog from "components/ProdutoImagem/CustomProdutoImagensDialog";
import MiniImagem from "components/ProdutoImagem/MiniImagem";
import { CustomButton } from "components/roundedbutton/CustomButton";
import useCatchApiError from 'hooks/useCatchApiError';
import useFlowRoles from "hooks/useFlowRoles";
import useHotkey from "hooks/useHotkey";
import useShowProgress from "hooks/useShowProgress";
import { useSnackbarCustom } from "hooks/useSnackCustom";
import useTabelaPreco from "layout/topbar/tabela-preco";
import { IConsumidor } from "model/cliente.model";
import { FlowEventoNotaEmitidaTypeDTO } from "pages/evento-nota-fiscal/evento-nota-fiscal.model";
import EventoNotaFiscal, { StateEventoNotaDialog } from "pages/evento-nota-fiscal/EventoNotaFiscal";
import DescontoInput from "pages/registra-venda/DescontoInput";
import ObservacaoDialog from "pages/registra-venda/ObservacaoDialog";
import { IProduto, StatusPedido } from "pages/registra-venda/registra-venda.model";
import TabelaPrecoPreferenciaDialog from "pages/registra-venda/tabela-preco-preferencia-dialog";
import CustomIFrame from "pages/Venda/Header/CustomIFrame";
import CustomLoading from "pages/Venda/Header/CustomLoading";
import VendaService from "pages/Venda/venda.service";
import { useCallback, useEffect, useRef, useState } from 'react';
import { useLocation, useNavigate } from "react-router-dom";
import { changeLinearFinalizaVenda, loadingWithOpt, Tipo } from "redux/features/blockuiSlice";
import { setDeposito, setTabelaPreco } from "redux/features/configuracoes";
import { addItemConsignado, concluirSalvarConsignado, deleteItemConsignado, removeItemConsignado, setClienteConsignado, setConsignado, setDescontoFixoConsignado, setIdsInfo, setTabelaPrecoConsignado, setVendedorConsignado, updateItemTableDataConsignado } from "redux/features/consignadoSlice";
import { setPagamentos } from "redux/features/pagamentoSlice";
import { setStateByProps, setTransportador } from "redux/features/stateSlice";
import { useAppDispatch, useAppSelector } from "redux/hooks";
import { customColors, theme } from "theme";
import { getValorTotalBruto } from "utils/desconto-utils";
import { ColumnData, currencyOf, isEmpty, resolve } from 'utils/util';
import ConsignadoService from '../consignado.service';
import { FlowConsignadoImpressaoDTO } from "../impressao/consignado-impressao.model";
import ConsignadoImpressaoService from "../impressao/consignado-impressao.service";
import ConsignadoPDF from "../impressao/ConsignadoPDF";
import MovimentacoesDialog from "../movimentacoes/MovimentacoesDialog";
import { SituacaoConsignado, SituacaoConsignadoClass, SituacaoConsignadoTableLabel } from '../situacao-consignado.model';
import { FlowConsignadoConsignarResponseDTO, FlowConsignadoDTO, FlowConsignadoItemDTO } from './consignado-detail.model';
import ProdutoService from "service/produto.service";
import { addImagensUuidProduto } from "redux/features/imagemReducer";

type ExtraColumns = { __checkbox: unknown; __options: unknown; __imagens: unknown };
type ItemExtraColumns = FlowConsignadoItemDTO & ExtraColumns;

type LocalState = {
    loading: boolean;
    openMovimentacaoDialog: boolean;
    shouldOpenTabelaPrecoDialog: boolean;
    openObservacaoDialog: boolean;
    openFixarDescontoDialog: boolean;
    uuidProduto: null | string
};

const initialState: LocalState = {
    loading: true,
    openMovimentacaoDialog: false,
    shouldOpenTabelaPrecoDialog: false,
    openObservacaoDialog: false,
    openFixarDescontoDialog: false,
    uuidProduto: null
};

const initialStateEventoNotaDialog: StateEventoNotaDialog = {
    open: false,
    info: {
        eventoType: FlowEventoNotaEmitidaTypeDTO.SEM_EVENTO,
        header: 'Consignado concluído'
    }
};

const columnWidths = {
    checkbox: 4,
    imagem: 5,
    produto: 45,
    estoque: 8,
    quantidade: 8,
    valorUnitario: 8,
    desconto: 10,
    total: 8,
    options: 4,
};

const ConsignadoDetail = () => {
    const {
        canMovimentacoes,
        canImprimir,
        canEditarConsignado,
        canConsignar,
        canConsignarOutros,
        canDevolucaoGerenciar,
        canGerarVendaGerenciar,
        canDescontoItem,
    } = useFlowRoles().consignado;
    const consignadoService = ConsignadoService();
    const vendaService = VendaService();
    const consignadoImpressaoService = ConsignadoImpressaoService();


    const { throwErrorMessage } = useCatchApiError();
    const { addError, addSuccess } = useSnackbarCustom();
    const navigate = useNavigate();

    const [localState, setLocalState] = useState(initialState);
    const [impressao, setImpressao] = useState(null as FlowConsignadoImpressaoDTO | null);
    const [urlDanfeState, setUrlDanfeState] = useState({ url: null as string | null, open: false });

    const state = useAppSelector(s => s.consignado);
    const configuracaoConsignado = useAppSelector(s => s.configuracoes.configuracaoConsignado);
    const preferencias = useAppSelector(s => s.preferencias);
    const estabelecimentoSelecionado = useAppSelector(e => e.estabelecimentoSelecionado);

    const [stateEventoNotaDialog, setStateEventoNotaDialog] = useState(initialStateEventoNotaDialog);
    const [openDialogTabelaPrecoPreferencia, setOpenDialogTabelaPrecoPreferencia] = useState(false);

    const dispatch = useAppDispatch();
    const { showProgress, hideProgress } = useShowProgress();
    const location = useLocation();
    const receivedParams: { uuid?: string; } = location.state;
    const { imagens } = useAppSelector(e => e.imagens)
    const produtoService = ProdutoService();

    // debounce pra evitar dar 'recurso em uso' quando executar duas ações que disparam o save do consignado
    const debounceSaveRef = useRef<ReturnType<typeof setTimeout> | null>(null);

    useHotkey([
        {
            keys: ['o', 'O'],
            alt: true,
            action: () => {
                setLocalState(prev => ({ ...prev, openObservacaoDialog: true }));
            },
        },

        {
            keys: ['m', 'M'],
            alt: true,
            action: () => {
                setLocalState(prev => ({ ...prev, openFixarDescontoDialog: true }));
            },
        },
    ]);

    const onOpenImage = useCallback((uuidProduto: string) => {
        setLocalState(prevState => ({
            ...prevState,
            uuidProduto
        }))
    }, [])

    const onCloseImagemDialog = useCallback(() => {
        setLocalState(prevState => ({
            ...prevState,
            uuidProduto: null
        }))
    }, [])


    const columns: ColumnData<ItemExtraColumns>[] = [
        {
            header: "",
            id: "imagem",
            key: '__imagens',
            textAlign: 'left',
            type: 'string',
            width: columnWidths.imagem,
            convert: (item) => {
                return (
                    <Box sx={{ width: `100%`, display: 'flex', alignItems: 'center' }}>
                        <MiniImagem
                            descritivo={item.sku.descritivo}
                            imagens={imagens.filter(e => e.uuidProduto === item.sku.uuidProduto)}
                            onOpenImage={() => onOpenImage(item.sku.uuidProduto)}
                            uuidProduto={item.sku.uuidProduto}
                            style={{
                                border: 0
                            }}
                        />
                    </Box>
                )
            }
        },
        {
            header: '',
            id: '__checkbox',
            key: '__checkbox',
            textAlign: 'center',
            type: 'custom',
            width: columnWidths.checkbox,
            convert: (_, { extraData }) => {
                const { situacao, indexRow } = extraData;

                const isChecked = state.tableData[situacao][indexRow].selecionado;
                const handleChange = (checked: boolean) => {
                    dispatch(updateItemTableDataConsignado({
                        situacao,
                        index: indexRow,
                        update: {
                            type: 'toggleSelection',
                            checked,
                        }
                    }));
                };

                return <Box sx={{ width: `100%`, display: 'flex', alignItems: 'center' }}>
                    <Checkbox checked={isChecked} onChange={(_, checked) => handleChange(checked)} />
                </Box>;
            }
        },
        {
            header: 'Produto',
            id: 'produto',
            key: 'sku.descritivo',
            textAlign: 'left',
            type: 'string',
            width: columnWidths.produto + columnWidths.estoque,
        },
        // {
        //     header: 'Estoque',
        //     id: 'estoque',
        //     key: 'saldo',
        //     textAlign: 'center',
        //     type: 'number',
        //     width: columnWidths.estoque,
        // },

        {
            header: 'Quantidade',
            id: 'quantidade',
            key: 'quantidade',
            textAlign: 'center',
            type: 'string',
            width: columnWidths.quantidade,
            convert: (item, { extraData }) => {
                const hasError = false;
                // (props.row.estoque === 0 || (props.row.quantidade > props.row.estoque)
                const { situacao, indexRow } = extraData;

                const handleChange = (value: string) => {
                    if (!value) return;
                    const quantidade = Number(value);
                    dispatch(updateItemTableDataConsignado({
                        situacao,
                        index: indexRow,
                        update: {
                            type: "changeQuantidade",
                            quantidade
                        }
                    }));
                };
                return <TextField
                    disabled={!canEditarConsignado || !SituacaoConsignadoClass.of(situacao).isAberto()}
                    // error={props.row.quantidade > props.row.estoque}
                    inputProps={{ inputMode: 'numeric', min: 1, style: { textAlign: 'center', color: hasError ? theme.palette.error.main : "" } }}
                    value={item.quantidade}
                    onKeyDown={e => e.key === '.' && e.preventDefault()}
                    onChange={e => { handleChange(e.target.value); }}
                    variant="standard"
                    type="number"
                />;
            }
        },

        {
            header: 'Valor unitário',
            id: 'valor-unid',
            key: 'sku.preco',
            textAlign: 'center',
            type: 'string',
            width: columnWidths.valorUnitario,
            convert: (item) => {
                return <>
                    {currencyOf(item.sku.preco)}
                </>;
            },
        },

        {
            header: 'Desconto',
            id: 'desconto',
            key: 'valorDesconto',
            textAlign: 'center',
            type: 'string',
            width: columnWidths.desconto,
            convert: (item, { extraData }) => <DescontoInputLocal item={item} extraData={extraData} />
        },

        {
            header: 'Total',
            id: 'total',
            key: 'valorTotalLiquido',
            textAlign: 'center',
            type: 'currency',
            width: columnWidths.total,
            convert: (item) => {
                return <>
                    {currencyOf(item.valorTotalLiquido)}
                </>;
            },
        },

        {
            header: '',
            id: '__options',
            key: '__options',
            textAlign: 'left',
            type: 'string',
            width: columnWidths.options,
            convert: (_, { extraData }) => {
                const { situacao, indexRow } = extraData;

                const handleDelete = () => {

                    if (isAberto() && state.tableData[situacao].length === 1) {
                        return addError({
                            id: 'consingando-deve-ter-um-itme',
                            message: 'O consignado deve ter pelo menos um item.',
                            closeable: true,
                            preventDuplicate: true
                        });
                    }
                    dispatch(deleteItemConsignado({ situacao, index: indexRow }));
                };

                if (!SituacaoConsignadoClass.of(situacao).isAberto()) return;
                return <Box sx={{ width: '100%' }}>
                    <IconButton
                        onClick={handleDelete}
                        disabled={!canEditarConsignado}
                        style={{ color: !canEditarConsignado ? theme.palette.text.disabled : theme.palette.primary.main }}
                    >
                        <Delete />
                    </IconButton>
                </Box>;
            }
        },
    ];

    const handleLoading = (loading: boolean) => {
        setLocalState(prev => ({ ...prev, loading }));
    };

    const estabRef = useRef(estabelecimentoSelecionado.uuid);

    useEffect(() => {
        if (estabRef.current !== estabelecimentoSelecionado.uuid) {
            handleLoading(false);
            navigate('/consignado');
        }
        //eslint-disable-next-line
    }, [estabelecimentoSelecionado]);

    useEffect(() => {
        if (!!receivedParams?.uuid) {
            consultar();
        } else {
            handleLoading(false);
        }
        //eslint-disable-next-line
    }, []);

    const consultar = () => {
        handleLoading(true);
        consignadoService.loadConsignado(receivedParams?.uuid ?? state.uuid!)
            .then(({ data }) => {
                setConsignadoLocal(data);
            })
            .catch(err =>
                throwErrorMessage(err)
            )
            .finally(() => {
                handleLoading(false);
            });
    };

    const setConsignadoLocal = (consignado: FlowConsignadoDTO) => {
        dispatch(setConsignado(consignado));
    };

    useEffect(() => {
        if (!state.shouldSave) return;

        const situacao = SituacaoConsignadoClass.of(state.situacao);
        const hasItensAbertos = !!state.tableData[SituacaoConsignado.ABERTO].length;
        const shouldSaveStatusAberto = situacao.isAberto() && hasItensAbertos;

        dispatch(concluirSalvarConsignado());
        if (shouldSaveStatusAberto || !situacao.isAberto()) {
            if (debounceSaveRef.current) clearTimeout(debounceSaveRef.current);
            debounceSaveRef.current = setTimeout(() => {
                debounceSaveRef.current = null;
                salvar();
            }, 100);
        }
        //eslint-disable-next-line
    }, [state.shouldSave]);

    useEffect(() => {
        return () => {
            if (debounceSaveRef.current) clearTimeout(debounceSaveRef.current);
        };
    }, []);


    const getImagensProdutoFull = useCallback(async (toSearch: Array<string>) => {
        try {
            const { data } = await produtoService.getImagensProdutoFull(toSearch)
            dispatch(addImagensUuidProduto(data))
        }
        catch { }
        //eslint-disable-next-line
    }, [])


    useEffect(() => {
        const toSearch = state.tableData[SituacaoConsignado.ABERTO].map(e => e.sku).map(e => e.uuidProduto)
        if (!isEmpty(toSearch)) {
            getImagensProdutoFull(toSearch)
        }
        //eslint-disable-next-line
    }, [state.tableData])

    const getConsignadoPayload = (): FlowConsignadoDTO | void => {
        if (!state.cliente) {
            return addError({ id: 'erro-sem-cliente', message: 'Selecione um cliente para continuar', closeable: true, preventDuplicate: true });
        }
        return {
            uuid: state.uuid,
            version: state.version,
            deposito: state.deposito,
            tabelaPreco: state.tabelaPreco,
            cliente: state.cliente!,
            vendedor: state.vendedor,
            itensAbertos: state.tableData[SituacaoConsignado.ABERTO],
            itensPendentes: [],
            itensSimbolicos: [],
        };
    };

    const salvar = () => {
        const consignado = getConsignadoPayload();
        if (!consignado) return;

        handleLoading(true);
        consignadoService.salvar(consignado)
            .then(({ data }) => {
                dispatch(setIdsInfo({ uuid: data.uuid, version: data.version, numero: data.numero }));
            })
            .catch((err) => {
                throwErrorMessage(err);
            })
            .finally(() => {
                handleLoading(false);
            });
    };

    const getDadosImpressao = (chaveAcesso: string) => {
        consignadoImpressaoService.impressao(state.uuid!, chaveAcesso)
            .then(({ data }) => {
                setImpressao(data);
            });
    };

    const finalizar = (tipo: 'consignar' | 'consignarOutros') => {
        const consignado = getConsignadoPayload();
        if (!consignado) return;

        let response: Promise<AxiosResponse<FlowConsignadoConsignarResponseDTO>>;

        if (consignado.itensAbertos.every(s => !s.selecionado)) {
            return addError({ id: 'erro-nenhum-item-selecionado', message: 'Selecione pelo menos um SKU para continuar', closeable: true, preventDuplicate: true });
        }

        showProgress({
            mensagens: {
                0: 'Finalizando consignação'
            }
        });

        switch (tipo) {
            case 'consignar':
                response = consignadoService.finalizarConsignado(consignado, false);
                break;

            case 'consignarOutros':
                response = consignadoService.finalizarConsignado(consignado, true);
                break;
        }

        response
            .then(({ data }) => {
                setConsignadoLocal(data.consignado);
                if (!!data.eventoNotaFiscal && !!data.eventoNotaType) {
                    if (!!data.urlDanfe) setUrlDanfeState({ url: data.urlDanfe, open: false });
                    setStateEventoNotaDialog(prev => ({
                        ...prev,
                        open: true,
                        info: {
                            ...prev.info,
                            eventoType: data.eventoNotaType!,
                            eventoSaida: data.eventoNotaFiscal!
                        }
                    }));
                } else {
                    if (canImprimir) getDadosImpressao(data.chaveAcesso);
                }
                dispatch(changeLinearFinalizaVenda({ progress: 100 }));
                addSuccess({ message: 'Consignação realizada com sucesso', closeable: true });
            })
            .catch((err) => {
                throwErrorMessage(err);
            })
            .finally(() => {
                dispatch(loadingWithOpt({
                    loading: false,
                    tipo: Tipo.CIRCULAR,
                    message: 'Finalizando consignação',
                    progress: 100,
                }));
                setTimeout(() => {
                    dispatch(loadingWithOpt({
                        loading: false,
                        tipo: Tipo.CIRCULAR,
                        message: "Salvando pedido",
                        progress: 0,
                    }));
                }, 300);
            });
    };

    const shouldDisableConsignar = () => {
        return !state.tableData[SituacaoConsignado.ABERTO].length
            || state.tableData[SituacaoConsignado.SIMBOLICO].some(s => s.selecionado)
            || state.tableData[SituacaoConsignado.DIVERGENTE].some(s => s.selecionado);
    };


    const floatingActions: FloatingActionsProps = {
        actions: [
            {
                label: 'Consignar outros',
                icon: 'fa-solid fa-handshake',
                onClick: () => {
                    finalizar('consignarOutros');
                },
                disabled: () => !canConsignarOutros || shouldDisableConsignar()
            },

            {
                label: 'Devolução consignado',
                icon: 'fa-solid fa-reply',
                onClick: () => {
                    navigate("/devolucao-consignado", {
                        state: {
                            uuid: state.uuid,
                            cliente: state.cliente?.descritivo,
                            vendedor: state.vendedor?.descritivo,
                            origem: 'detail',
                        }
                    });
                },
                disabled: () => !canDevolucaoGerenciar || !state.uuid || isAberto()
            },

            {
                label: 'Gerar venda',
                icon: 'fa-solid fa-cart-arrow-down',
                onClick: () => {

                    if (!!state.tableData[SituacaoConsignado.ABERTO].length) {
                        return addError({
                            message: `Não é possivel gerar venda com SKU's abertos!`,
                            closeable: true,
                            id: 'nao-e-possivel-gerar-venda-skus-abertos'
                        });
                    }

                    showProgress({
                        mensagens: {
                            0: 'Devolvendo itens',
                            50: 'Gerando venda',
                        },
                    });

                    consignadoService.gerarVenda(state.uuid!)
                        .then(({ data }) => {
                            vendaService.carregaPedido(data.uuid)
                                .then(({ data }) => {
                                    if (data.statusPedido === StatusPedido.ABERTO.toString().toUpperCase()) {
                                        if (data.tabelaPreco) dispatch(setTabelaPreco(data.tabelaPreco));
                                        if (data.deposito) dispatch(setDeposito(data.deposito));
                                        if (data.transportador) dispatch(setTransportador(data.transportador));
                                        data.itens.forEach(e => e.estoque = -1);
                                        dispatch(setStateByProps(data));
                                        dispatch(setPagamentos({ itens: [], itensTroca: [] }));
                                        setTimeout(() => {
                                            addSuccess({ message: 'Venda gerada com sucesso. Redirecionando para o PDV!' });
                                            navigate("/registra-venda", { state: true });
                                        }, 200);
                                        return;
                                    }
                                })
                                .catch(() => {
                                    addError({ message: "Sistema temporariamente indisponivel. Se o erro persistir, contate o suporte", closeable: true, persist: true, id: "sistema-indisponivel-error", preventDuplicate: true });
                                });
                        })
                        .catch(throwErrorMessage)
                        .finally(() => {
                            setTimeout(() => {
                                hideProgress();
                            }, 300);
                        });
                },
                disabled: () => !canGerarVendaGerenciar || !state.uuid || isAberto()
            },

            {
                label: 'Fixar desconto (Alt + M)',
                icon: 'fa-regular fa-percent',
                disabled: () => !canDescontoItem,
                onClick: () => {
                    setLocalState(prev => ({ ...prev, openFixarDescontoDialog: true }));
                }
            },

            {
                label: 'Adicionar observação (Alt + O)',
                icon: 'fa-solid fa-pen-to-square',
                disabled: () => !state.uuid,
                onClick: () => {
                    setLocalState(prev => ({ ...prev, openObservacaoDialog: true }));
                }
            },
        ],
        onClose: (r) => {
            if (['blur', 'toggle'].includes(r)) {
                skuinputRef.current?.focus();
            }
        }
    };

    const getRows = () => {
        const entries = Object.entries(state.tableData);
        return entries.filter(([_, itens]) => !!itens.length);
    };

    const skuinputRef = useRef<SkuInputComponent>(null);
    const consumidorInputRef = useRef<ConsumidorInputComponent>(null);
    const vendedorInputRef = useRef<VendedorInputComponent>(null);

    const handelSelectSkuInput = (item: IProduto | null, isAdding: boolean) => {
        if (!item) return;
        if (isAdding) {
            dispatch(addItemConsignado(item));
        } else {
            dispatch(removeItemConsignado(item));
        }
    };

    const isRowSelected = (situacao: string) => {
        const arr = state.tableData[situacao];
        let totalSelecionado = 0;
        arr.forEach(s => {
            if (s.selecionado) {
                totalSelecionado++;
            }
        });
        return totalSelecionado === 0 ? false : totalSelecionado === arr.length ? true : 'parcial';
    };

    const handleSelectRow = (checked: boolean, situacao: string) => {
        dispatch(updateItemTableDataConsignado({
            situacao,
            update: {
                type: 'toggleSelection',
                checked,
            }
        }));
    };

    const isAberto = () => {
        return SituacaoConsignadoClass.of(state.situacao).isAberto();
    };

    const { atualizarOuRemoverItensPedido } = useTabelaPreco();

    useEffect(() => {
        const tabelasPreferencias = preferencias.tabelasPreco;
        let tabelaToUse = null;
        if (!tabelasPreferencias) {
            tabelaToUse = configuracaoConsignado?.tabelaPrecoPadrao ?? null;
            dispatch(setTabelaPrecoConsignado(tabelaToUse));
        } else if (tabelasPreferencias.length === 1) {
            tabelaToUse = tabelasPreferencias[0];
            dispatch(setTabelaPrecoConsignado(tabelaToUse));
        }

        if (tabelaToUse) {
            atualizarOuRemoverItensPedido(tabelaToUse!);
        }
        //eslint-disable-next-line
    }, [preferencias]);

    useEffect(() => {
        const temMaisDeUmaTabela = (preferencias.tabelasPreco?.length ?? 0) > 1;
        if (temMaisDeUmaTabela && localState.shouldOpenTabelaPrecoDialog && !!state.cliente) {
            setOpenDialogTabelaPrecoPreferencia(true);
            setLocalState(prev => ({ ...prev, shouldOpenTabelaPrecoDialog: false }));
        }
    }, [localState.shouldOpenTabelaPrecoDialog, state.cliente, preferencias]);



    return <>
        <Container
            maxWidth="xl"
            sx={{
                margin: '20px auto',
                display: 'grid',
                gap: '20px',
                position: 'relative'
            }}>

            {!!state.numero && <Box
                sx={{
                    position: 'absolute',
                    left: '26px',
                    top: '-61px',
                }}>

                <Typography
                    sx={{
                        color: theme.palette.text.primary,
                        fontWeight: 'bold',
                        fontSize: '22px'
                    }}
                >Ordem: {state.numero}</Typography>
            </Box>
            }


            <Grid2 container spacing={2}>
                <Grid2 xs={12} sm={6} lg={6}>
                    <ConsumidorInput
                        ref={consumidorInputRef}
                        consumidor={state.cliente}
                        onSelect={(item, reason) => {
                            const reasonClick = reason === 'click';
                            if (reasonClick) {
                                const consumidor = item as IConsumidor | null;
                                const reps = consumidor?.representantes ?? [];
                                if (reps.length === 1) {
                                    const found = vendedorInputRef.current?.allVendedores.find(s => s.uuid === reps[0]);
                                    if (!!found) {
                                        dispatch(setVendedorConsignado({ vendedor: found, shouldSave: false }));
                                    }
                                }
                            }
                            if (reasonClick) setLocalState(prev => ({ ...prev, shouldOpenTabelaPrecoDialog: true }));
                            dispatch(setClienteConsignado({ cliente: item, shouldSave: reasonClick }));

                        }}
                        disable={!canEditarConsignado || !isAberto() || !!getRows().length}
                        label='Cliente *'
                    />
                </Grid2>

                <Grid2 xs={12} sm={6} lg={6}>
                    <VendedorInput
                        ref={vendedorInputRef}
                        vendedor={state.vendedor}
                        onSelect={(item, reason) => {
                            dispatch(setVendedorConsignado({ vendedor: item, shouldSave: reason === 'click' }));
                        }}
                        hideOutrosVendedores
                    />
                </Grid2>

                <Grid2 xs={12} sm={6} lg={6}>
                    <SkuInput
                        ref={skuinputRef}
                        onSelect={handelSelectSkuInput}
                        getOptionLabel={item => `${item.codigoSku} - ${item.nome} / ${item.cor} / ${item.tamanho}`}
                        disabled={!canEditarConsignado || !state.cliente}
                    />
                </Grid2>
            </Grid2>

            <Grid2 container spacing={2}>
                <Grid2 xs={12} height="auto">
                    <InfiniteScrollVirtuoso
                        data={getRows()}
                        heightScale={'calc(100vh - 493px)'}
                        fixedHeaderContent={(tableProps) => HeaderInfiniteScrollVirtuoso({ ...tableProps, columns })}
                        renderItem={(tableProps) => TableCustomRow({ ...tableProps, columns, selected: isRowSelected(tableProps.data[0]), onSelectRow: (checked) => { handleSelectRow(checked, tableProps.data[0]); } })}
                        fixedFooterContent={(tableProps) => <CustomFooter {...tableProps} />}
                        emptyRender={() => {
                            return <TableRow>
                                <TableCell
                                    colSpan={999}
                                    sx={{
                                        fontSize: '48px',
                                        color: customColors.cinzaClaro,
                                        padding: 0,
                                        userSelect: 'none',
                                    }}>
                                    <Box sx={{
                                        position: 'absolute',
                                        display: 'flex',
                                        alignItems: 'center',
                                        justifyContent: 'center',
                                        height: 'calc(100vh - 550px)',
                                        width: '100%'
                                    }}>
                                        Não há nenhum item aberto.
                                    </Box>
                                </TableCell>
                            </TableRow>;
                        }}
                    />
                </Grid2>
            </Grid2>

            <Grid2 container spacing={2} sx={{ textAlign: "center" }}>
                <CardLocal
                    id={'qtd-consignada'}
                    qtdLabel="Qtde. consignada"
                    qtd={state.qtdValores?.quantidadeConsignada}
                    valorLabel="Valor consignado"
                    valor={state.qtdValores?.valorConsignado}
                />
                <CardLocal
                    id={'qtd-devolvida'}
                    qtdLabel="Qtde. devolvida"
                    qtd={state.qtdValores?.quantidadeDevolvida}
                    valorLabel="Valor devolvido"
                    valor={state.qtdValores?.valorDevolvido}
                />
                <CardLocal
                    id={'saldo'}
                    qtdLabel="Saldo"
                    qtd={state.qtdValores?.saldo}
                    valorLabel="Valor saldo"
                    valor={state.qtdValores?.valorSaldo}
                />
                <CardLocal
                    id={'qtd-vendida'}
                    qtdLabel="Qtde. vendida"
                    qtd={state.qtdValores?.quantidadeVendida}
                    valorLabel="Valor vendido"
                    valor={state.qtdValores?.valorVendido}
                />
            </Grid2>

            <Grid2 container spacing={2} sx={{ textAlign: "center", display: 'flex', justifyContent: 'space-between' }}>

                <CustomButton
                    variant="contained"
                    startIcon={<Icon className='fa-solid fa-arrow-left' sx={{ width: '25px' }} />}
                    containerStyle={{
                        boxShadow: "2px 2px 10px rgba(0,0,0,0.35)"
                    }}
                    color="error"
                    onClick={() => { navigate('/consignado'); }}
                >
                    Voltar
                </CustomButton>

                <Box sx={{
                    display: 'flex',
                    maxHeight: '50px',
                    position: 'relative',
                    gap: '10px',
                    alignItems: 'flex-end',
                }}>

                    <CustomButton
                        variant="contained"
                        startIcon={<Icon className='fa-solid fa-file-invoice-dollar' sx={{ width: '25px' }} />}
                        containerStyle={{
                            boxShadow: "2px 2px 10px rgba(0,0,0,0.35)"
                        }}
                        disabled={!canMovimentacoes || !state.uuid || isAberto()}
                        color='secondary'
                        onClick={() => {
                            setLocalState(prev => ({ ...prev, openMovimentacaoDialog: true }));
                        }}
                    >
                        Movimentações
                    </CustomButton>

                    <Tooltip
                        title={`Só é possível consignar SKU's abertos`}
                        disableHoverListener={!shouldDisableConsignar()}
                    >
                        <span>
                            <CustomButton
                                variant="contained"
                                startIcon={<Icon className='fa-solid fa-handshake' sx={{ width: '25px' }} />}
                                containerStyle={{
                                    boxShadow: "2px 2px 10px rgba(0,0,0,0.35)"
                                }}
                                color='success'
                                onClick={() => {
                                    finalizar('consignar');
                                }}
                                disabled={!canConsignar || shouldDisableConsignar()}
                            >
                                Consignar
                            </CustomButton>
                        </span>
                    </Tooltip>

                    <FloatingActions
                        {...floatingActions}
                    />
                </Box>
            </Grid2>

            {localState.loading && <CustomLoading />}

            <TabelaPrecoPreferenciaDialog
                open={openDialogTabelaPrecoPreferencia}
                setOpen={setOpenDialogTabelaPrecoPreferencia} />

            <EventoNotaFiscal
                state={stateEventoNotaDialog}
                setState={setStateEventoNotaDialog}
                onClose={() => {
                    if (urlDanfeState.url) {
                        setUrlDanfeState(prev => ({ ...prev, open: true }));
                    } else {
                        if (canImprimir) getDadosImpressao(stateEventoNotaDialog.info.eventoSaida!.chaveAcesso);
                    }
                }}
            />

        </Container>

        <MovimentacoesDialog
            uuidConsignado={state.uuid!}
            open={localState.openMovimentacaoDialog}
            onClose={() => {
                setLocalState(prev => ({ ...prev, openMovimentacaoDialog: false }));
                consultar();
            }}
        />

        <ObservacaoDialog
            open={localState.openObservacaoDialog}
            onCloseHistoricoDialog={() => setLocalState(prev => ({ ...prev, openObservacaoDialog: false }))}
            getPreviusObs={async () => {
                return (await consignadoService.getObservacao(state.uuid!)).data?.observacao;
            }}
            dispatchObs={obs => { consignadoService.setObservacao(state.uuid!, obs); }}
        />

        <FixarDescontoDialog
            open={localState.openFixarDescontoDialog}
            onConfirm={value => {
                dispatch(setDescontoFixoConsignado(value));
                setLocalState(prev => ({ ...prev, openFixarDescontoDialog: false }));
            }}
            onClose={() => setLocalState(prev => ({ ...prev, openFixarDescontoDialog: false }))}
            onClear={() => dispatch(setDescontoFixoConsignado(null))}
            percentual={state.descontoFixo ?? 0}
        />

        {!!impressao && <ConsignadoPDF
            dados={impressao}
            onClose={() => {
                setImpressao(null);
                navigate('/consignado');
            }}
        />}

        {urlDanfeState.open && !!urlDanfeState.url && <CustomIFrame
            url={urlDanfeState.url}
            onClose={() => {
                setUrlDanfeState({ open: false, url: null });
                if (canImprimir) getDadosImpressao(stateEventoNotaDialog.info.eventoSaida!.chaveAcesso);
            }}
        />}

        {!!localState.uuidProduto && (
            <CustomProdutoImagensDialog
                onClose={onCloseImagemDialog}
                uuidProduto={localState.uuidProduto}
                imagens={imagens.find(e => e.uuidProduto === localState.uuidProduto) ?? null}
            />
        )}

    </>;
};

type SelectedRowsProps = {
    onSelectRow: (checked: boolean) => void;
    selected: boolean | 'parcial';
};

const TableCustomRow = ({ calcWidth, data, index, columns, selected, onSelectRow }: RowInfiniteScrollVirtuosoProps<[string, FlowConsignadoItemDTO[]], ItemExtraColumns> & SelectedRowsProps) => {
    const [situacao, itens] = data;
    const label = SituacaoConsignadoTableLabel[situacao as keyof typeof SituacaoConsignadoTableLabel];
    const resolveWrapper = (data: any, key: string) => resolve(data, key);

    return <TableCell
        colSpan={999}
        style={{ padding: 0 }}
    >

        <Table>
            <TableBody>
                <TableRow sx={{ background: customColors.confereridoBg }}>
                    <TableCell colSpan={1} sx={{ padding: '0 0 0 15px', lineHeight: '30px', width: calcWidth(columns[0].width, 15) }}>
                        <Box sx={{ width: `100%`, display: 'flex', alignItems: 'center' }}>
                            <Checkbox
                                checked={selected === true}
                                indeterminate={selected === 'parcial'}
                                onChange={(_, checked) => onSelectRow(checked)}
                            />
                        </Box>
                    </TableCell>

                    <TableCell colSpan={999} sx={{ padding: '0 0 0 15px', lineHeight: '30px' }}>
                        <Typography
                            fontWeight={600}
                            textAlign={'left'}
                            sx={{
                                width: '100%',
                                color: theme.palette.background.default
                            }}
                            color={theme.palette.background.default}
                        >
                            {label}
                        </Typography>
                    </TableCell>
                </TableRow>

                <TableRow sx={{ '& > *': { borderBottom: 'unset' } }}>
                    <TableCell sx={{ padding: 0 }} colSpan={999}>
                        <Table size="small">
                            <TableBody>
                                {itens.map((item, indexRow) => {
                                    return <TableRow
                                        key={situacao + "-" + item.sku.uuid + "-" + indexRow + "-row"}
                                    >
                                        {columns.map((col, indexCol) => {
                                            return <TableCell
                                                key={col.key + index + indexRow + indexCol + '-row'}
                                                sx={{
                                                    height: '30px',
                                                    minWidth: col.minWidth,
                                                    maxWidth: col.maxWidth,
                                                    width: calcWidth(col.width, 15),
                                                    textAlign: col.textAlign,
                                                    fontSize: '14px',
                                                    padding: 0,
                                                    paddingLeft: '15px',
                                                    color: theme.palette.common.black,
                                                    borderBottom: indexRow === itens.length - 1 ? 'unset' : undefined,
                                                }}
                                            >
                                                {
                                                    col.convert?.(item as any, { column: col, extraData: { calcWidth, indexRow, situacao } }) ?? resolveWrapper(item, col.key)
                                                }
                                            </TableCell>;
                                        })}
                                    </TableRow>;
                                })}
                            </TableBody>
                        </Table>
                    </TableCell>
                </TableRow>
            </TableBody>
        </Table>
    </TableCell>;
};

const CustomFooter = (param: InfiniteScrollTableProps & { data: [string, FlowConsignadoItemDTO[]][]; }) => {
    const itensAbertos = param.data.filter(s => s[0] === SituacaoConsignado.ABERTO)[0][1];

    const totalizadores = itensAbertos.reduce((acc, curr) => {
        const currQtd = curr.quantidade;
        const currValorTotal = (curr.sku.preco * curr.quantidade);
        return {
            quantidade: acc.quantidade + currQtd,
            valorTotal: acc.valorTotal + currValorTotal,
            valorTotalLiquido: acc.valorTotalLiquido + currValorTotal - curr.valorDesconto
        };
    }, {
        quantidade: 0,
        valorTotal: 0,
        valorTotalLiquido: 0
    });

    return <TableRow className="glassmorphism">
        <TableCell
            colSpan={3}
            sx={{
                padding: "15px",
                borderLeft: 0,
                borderRight: 0,
            }}
        >
            <span className="footerText">Total da venda</span>
        </TableCell>


        <TableCell
            sx={{
                padding: "15px",
                borderLeft: 0,
                borderRight: 0,
            }}
            align="center"
        >
            <span className="footerText">{totalizadores.quantidade}</span>
        </TableCell>

        <TableCell
            sx={{
                padding: "15px",
                borderLeft: 0,
                borderRight: 0,
            }}
            align="center"
        >
            <span className="footerText">{currencyOf(totalizadores.valorTotal)}</span>
        </TableCell>

        <TableCell
            sx={{
                padding: "15px",
                borderLeft: 0,
                borderRight: 0,
            }}
            align="center"
        />

        <TableCell
            sx={{
                padding: "15px",
                borderLeft: 0,
                borderRight: 0,
            }}
            align="center"
        >
            <span className="footerText">{currencyOf(totalizadores.valorTotalLiquido)}</span>
        </TableCell>

        <TableCell
            sx={{
                padding: "15px",
                borderLeft: 0,
                borderRight: 0,
            }}
            align="center"
        />
    </TableRow>;
};

const CardLocal = (props: { id: string; qtdLabel: string, qtd: number, valorLabel: string; valor: number; }) => {
    return <Grid2 xs={12} sm={6} md={3} lg={3}>
        <CardTotalizador id={props.id}>
            <Box sx={{ display: 'flex', flexDirection: 'row', justifyContent: 'space-between', alignItems: 'center', height: '50%' }}>
                <CardTotalizadorLabel
                    id={`${props.id}-qtd`}
                    label={props.qtdLabel + ':'}

                />
                <CardTotalizadorValue
                    id={`${props.id}-qtd`}
                    value={props.qtd}
                />
            </Box>

            <Box sx={{ display: 'flex', flexDirection: 'row', justifyContent: 'space-between', alignItems: 'center', height: '50%' }}>
                <CardTotalizadorLabel
                    id={`${props.id}-valor`}
                    label={props.valorLabel + ':'}
                />
                <CardTotalizadorValue
                    id={`${props.id}-valor`}
                    value={currencyOf(props.valor)}
                />
            </Box>
        </CardTotalizador>
    </Grid2>;
};

const DescontoInputLocal = ({ item, extraData }: { item: ItemExtraColumns; extraData: { situacao: SituacaoConsignado, indexRow: number; }; }) => {
    const { situacao, indexRow } = extraData;
    const { canDescontoItem } = useFlowRoles().consignado;
    const [localValue, setLocalValue] = useState(0);
    const dispatch = useAppDispatch();

    const toggleTipoDesconto = () => {
        dispatch(updateItemTableDataConsignado({
            situacao,
            index: indexRow,
            update: { type: 'toggleTipoDesconto' },
        }));
    };

    const handleChange = () => {
        dispatch(updateItemTableDataConsignado({
            situacao,
            index: indexRow,
            update: { type: 'changeDesconto', valor: localValue },
        }));
    };

    return <Box sx={{ paddingBottom: '8px' }}>
        <DescontoInput
            onBlur={() => handleChange()}
            item={{
                tipoDesconto: item.tipoDesconto,
                valorDesconto: item.valorDesconto,
                percentualDesconto: item.percentualDesconto,
                valorTotalBruto: getValorTotalBruto(item.quantidade, item.valorUnitario),
                onChangeDesconto: setLocalValue,
                uuid: item.sku.uuid
            }}
            inputProps={{
                style: { textAlign: 'center' },
            }}
            iconButtonProps={{
                onToggleTipoDesconto: toggleTipoDesconto,
                percentoProps: {
                    color: theme.palette.primary.main,
                },
                valorProps: {
                    color: theme.palette.primary.main,
                }
            }}
            isVisualizar={!canDescontoItem || !SituacaoConsignadoClass.of(situacao).isAberto()}
            naoUsarIsVisualizarParaBotao={canDescontoItem}
            origem="ROW"
        />
    </Box>;
};
export default ConsignadoDetail;
